export default {
    car_00001: "Please input group name",
    car_00002: "EV",
    car_00003: "Generate and bundle plug-and-play cards",
    car_00004: "Add EV",
}